document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.querySelector("#product-grid");
  const paginationContainer = document.querySelector(".pagination-wrapper, .pagination");

  if (!productGrid || !paginationContainer) return;

  let isLoading = false;

  // Use IntersectionObserver to look for the pagination block coming into view
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // Trigger when the pagination wrapper is 300px away from the bottom of the viewport
      if (entry.isIntersecting && !isLoading) {
        const nextPageLink = paginationContainer.querySelector("a[href*='page=']");
        if (!nextPageLink) return; // No more pages left to load

        const nextPageUrl = nextPageLink.getAttribute("href");
        loadNextPage(nextPageUrl);
      }
    });
  }, { rootMargin: "0px 0px 300px 0px" }); // Pre-loads elements early for a seamless experience

  function loadNextPage(url) {
    isLoading = true;
    showLoadingSpinner(true);

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        
        // Match both Dawn's default class (.grid__item) or fallback list-items (li)
        const newProducts = doc.querySelectorAll("#product-grid .grid__item, #product-grid li");
        const newPagination = doc.querySelector(".pagination-wrapper, .pagination");

        // Append new product elements cleanly into the active layout grid
        newProducts.forEach((product) => {
          productGrid.appendChild(product);
        });

        // Swap the existing pagination blocks to obtain the next sequential page URL
        if (newPagination && newPagination.querySelector("a[href*='page=']")) {
          paginationContainer.innerHTML = newPagination.innerHTML;
        } else {
          // If no next page exists, terminate the listener and hide the container
          paginationContainer.style.display = 'none';
          observer.unobserve(paginationContainer);
        }

        isLoading = false;
        showLoadingSpinner(false);
      })
      .catch((error) => {
        console.error("Error loading next page:", error);
        isLoading = false;
        showLoadingSpinner(false);
      });
  }

  function showLoadingSpinner(visible) {
    let spinner = document.querySelector("#infinite-scroll-spinner");
    if (!spinner && visible) {
      spinner = document.createElement("div");
      spinner.id = "infinite-scroll-spinner";
      spinner.innerHTML = `<div class="scroll-loader"></div>`;
      spinner.setAttribute("style", "display:flex; justify-content:center; padding:30px; width:100%; clear:both;");
      productGrid.parentNode.insertBefore(spinner, paginationContainer);
    }
    if (spinner) {
      spinner.style.display = visible ? "flex" : "none";
    }
  }

  // Set the observer target
  observer.observe(paginationContainer);
});
